
window.addEventListener("load", function() {
  console.log("[Scroll Fix] Window load complete. Waiting 1000ms...");

  setTimeout(function() {
    console.log("[Scroll Fix] 1000ms timeout finished. Searching for '.after_form_submit'...");

    // 1. Select the success message container
    var successDiv = document.querySelector('.after_form_submit');

    if (!successDiv) {
      console.error("[Scroll Fix] FAILURE: Target div '.after_form_submit' still NOT found. The app might be loading slower than 1s.");
      return;
    } 
    
    console.log("[Scroll Fix] SUCCESS: Target div found. Attaching observer now.");

    // 2. Define the observer behavior
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === "style") {
          var displayStyle = window.getComputedStyle(successDiv).display;
          console.log("[Scroll Fix] Mutation detected. New display style: " + displayStyle);

          if (displayStyle !== 'none') {
             console.log("[Scroll Fix] Success message visible. Scrolling to view...");
             
             // Small delay to ensure the browser has repainted the new height
             setTimeout(function(){
               successDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
             }, 100); 
          }
        }
      });
    });

    // 3. Start watching
    observer.observe(successDiv, { attributes: true });

  }, 1000); // 1000ms delay after window load
});
